/* New In-Store: newest products from the overall catalogue via the Storefront
   API (sortKey CREATED_AT, reverse) — mirrors the headless site's
   NEWEST_PRODUCTS_QUERY. Renders cards matching snippets/product-card.liquid. */
(function () {
  var section = document.querySelector('[data-newest-section]');
  if (!section || section.dataset.newestInit) return;
  section.dataset.newestInit = '1';

  var count = parseInt(section.dataset.count || '10', 10);
  var token = section.dataset.token;
  var loggedIn = section.dataset.loggedIn === '1';
  var gated = (section.dataset.gatedVendors || '')
    .split('|')
    .map(function (v) { return v.trim().toLowerCase().replace(/[^a-z0-9]/g, ''); })
    .filter(Boolean);

  var query = 'query($n: Int!) { products(first: $n, sortKey: CREATED_AT, reverse: true) { edges { node {' +
    ' title handle vendor availableForSale' +
    ' atl: metafield(namespace: "custom", key: "made_in_atlantic_canada") { value } origin: metafield(namespace: "custom", key: "country_of_origin") { value }' +
    ' featuredImage { url altText }' +
    ' variants(first: 1) { edges { node { id price { amount } compareAtPrice { amount } availableForSale } } }' +
    ' } } } }';

  function money(amount) {
    return '$' + parseFloat(amount).toFixed(2);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }


  function badgesHtml(node) {
    var atl = node.atl && node.atl.value === 'true';
    var can = atl || (node.origin && node.origin.value === 'Canada');
    if (!atl && !can) return '';
    var h = '<div class="lum-pcard__badges">';
    if (atl && section.dataset.badgeAtlantic) h += '<img src="' + section.dataset.badgeAtlantic + '" alt="Made in Atlantic Canada" title="Made in Atlantic Canada" width="28" height="28" loading="lazy" class="lum-pcard__local">';
    if (can && section.dataset.badgeCanada) h += '<img src="' + section.dataset.badgeCanada + '" alt="Made in Canada" title="Made in Canada" width="28" height="28" loading="lazy" class="lum-pcard__local lum-pcard__local--canada">';
    return h + '</div>';
  }

  function cardHtml(node) {
    var v = node.variants.edges[0] ? node.variants.edges[0].node : null;
    var vendorNorm = (node.vendor || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    var isGated = gated.indexOf(vendorNorm) !== -1 && !loggedIn;
    var onSale = v && v.compareAtPrice && parseFloat(v.compareAtPrice.amount) > parseFloat(v.price.amount);
    var sep = node.featuredImage && node.featuredImage.url.indexOf('?') === -1 ? '?' : '&';
    var img = node.featuredImage
      ? '<img src="' + node.featuredImage.url + sep + 'width=400" alt="' + esc(node.title) + '" width="400" height="400" loading="lazy" decoding="async" class="max-w-full max-h-full w-auto h-auto object-contain group-hover:scale-105 transition-all duration-300" style="max-height:85%;max-width:85%">'
      : '<div class="text-muted-foreground text-sm">No image</div>';
    var priceBlock;
    if (isGated) {
      priceBlock = '<span class="text-sm text-primary font-medium flex items-center gap-1">Login to view price</span>' +
        '<a href="/account/login" class="inline-flex items-center justify-center rounded-md font-medium border border-input bg-background hover:bg-accent h-11 min-h-[44px] px-3 text-xs">Login</a>';
    } else {
      var sale = onSale ? '<span class="inline-flex items-center rounded-full text-[10px] px-1.5 py-0 h-4 bg-primary text-primary-foreground font-semibold">SALE</span>' : '';
      var compare = onSale ? '<span class="text-xs text-muted-foreground line-through">' + money(v.compareAtPrice.amount) + '</span>' : '';
      var buy = v && v.availableForSale
        ? '<form action="/cart/add" method="post" class="m-0"><input type="hidden" name="id" value="' + v.id.split('/').pop() + '"><input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="inline-flex items-center justify-center gap-1 rounded-md font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-11 min-h-[44px] px-3 text-xs transition-colors">Add</button></form>'
        : '<span class="inline-flex items-center justify-center rounded-md font-medium bg-primary text-primary-foreground opacity-50 h-11 min-h-[44px] px-3 text-xs">Out of Stock</span>';
      priceBlock = '<div class="flex flex-col gap-0.5">' + compare +
        '<div class="flex items-center gap-2"><span class="text-lg font-bold text-primary">' + (v ? money(v.price.amount) : '') + '</span>' + sale + '</div></div>' + buy;
    }
    return '<div class="lum-catrail__item" data-catrail-item>' +
      '<a href="/products/' + node.handle + '" class="group block lum-pcard">' +
      '<div class="relative w-full aspect-square bg-background overflow-hidden flex items-center justify-center p-3 sm:p-4">' + img + badgesHtml(node) + '</div>' +
      '<div class="p-3 space-y-2">' +
      '<span class="text-xs text-muted-foreground font-medium uppercase tracking-wide inline-block">' + esc(node.vendor) + '</span>' +
      '<h3 class="font-medium text-sm line-clamp-2 leading-tight group-hover:text-primary transition-colors min-h-[2.5rem]">' + esc(node.title) + '</h3>' +
      '<div class="flex items-center justify-between">' + priceBlock + '</div>' +
      '</div></a></div>';
  }

  fetch('https://' + window.Shopify.shop + '/api/2025-07/graphql.json', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
    body: JSON.stringify({ query: query, variables: { n: count } })
  })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var edges = (d.data && d.data.products && d.data.products.edges) || [];
      var grid = section.querySelector('[data-newest-grid]');
      var empty = section.querySelector('[data-newest-empty]');
      if (!edges.length) {
        empty.querySelector('[data-newest-spinner]').hidden = true;
        empty.querySelector('[data-newest-empty-text]').hidden = false;
        return;
      }
      grid.innerHTML = edges.map(function (e) { return cardHtml(e.node); }).join('');
      empty.hidden = true;
      var rail = section.querySelector('[data-catrail-shell]');
      rail.hidden = false;
      section.querySelector('[data-newest-cta]').hidden = false;
      // cards arrived after page load, so start the marquee now that they exist
      rail.setAttribute('data-catrail', '');
      if (window.LumRailInit) window.LumRailInit(rail);
    })
    .catch(function () {
      var empty = section.querySelector('[data-newest-empty]');
      empty.querySelector('[data-newest-spinner]').hidden = true;
      empty.querySelector('[data-newest-empty-text]').hidden = false;
    });
})();
